import { Sprite } from '../../odie';

import { app } from '../app';
import { IAnimation } from '../../lib/pattern/IAnimation';
import { ParticleEmitter } from '../particles/ParticleEmitter';
import { config } from '../defs/config';
import { getMatch2AssetPath } from '../util/assets';
import { RocketBlockView } from '../views/blocks/RocketBlockView';

const manifest = {
  rocket: 'fx.rocket/fx.rocket.png',
  exhaust: 'fx.rocket/fx.rocket.exhaust.png',
  smoke: [
    'fx.rocket/fx.rocket.smoke1.png',
    'fx.rocket/fx.rocket.smoke2.png',
    'fx.rocket/fx.rocket.smoke3.png',
    'fx.rocket/fx.rocket.smoke4.png',
  ],
};

/*
    fireworks animation
*/
export class RocketAnimation extends Sprite implements IAnimation {
  // fields
  //-------------------------------------------------------------------------
  // scene
  private _exhaust?: Sprite;
  // animations
  private _smokeEmitter?: ParticleEmitter;
  private _exhaustAnimation?: gsap.core.Timeline;

  // init
  //-------------------------------------------------------------------------
  public static assets(): string[] {
    return [];
  }

  // impl
  //-------------------------------------------------------------------------
  public async start(big: boolean): Promise<void> {
    const view = new RocketBlockView({ id: 'rh', type: 'rocket' });
    view.y -= 45;
    view.animation.play(`rocket_projectile_${big ? 'big' : 'small'}`);
    this.addChild(view);

    // create smoke emitter
    this._smokeEmitter = this._createSmokeEmitter();
    this.addChild(this._smokeEmitter.view);
    this._smokeEmitter.start();
  }

  public stop() {
    // stop animations
    this._exhaustAnimation?.kill();
    this._smokeEmitter?.stop();

    // despawn
    if (this._exhaust) this.removeChild(this._exhaust);
    if (this._smokeEmitter) this.removeChild(this._smokeEmitter.view);
  }

  // private: factory
  //-------------------------------------------------------------------------
  private _createExhaust(): Sprite {
    const exhaust = Sprite.from(manifest.exhaust);
    exhaust.scaleX = 1.5;
    exhaust.anchorX = exhaust.anchorY = 0.5;
    exhaust.x = -45;
    exhaust.alpha = 0.75;
    return exhaust;
  }

  private _createSmokeEmitter(): ParticleEmitter {
    // create
    const emitter = app.particles.create({
      textures: manifest.smoke.map((path) => getMatch2AssetPath(path)),
      rate: 0.05,
      limit: 64,
      duration: 2,
      velocity: { x: -config.sim.rocket.speed * 0.7, y: 0 },
      scale: [
        { x: 0.5, y: 0.5 },
        { x: 1, y: 1 },
      ],
      behaviors: [
        { type: 'explode', magnitude: [16, 32] },
        { type: 'scale', to: 0 },
        { type: 'tint', from: 0xfafafa, to: 0xffffff },
        { type: 'kinematic' },
      ],
    });
    // flex(, { left: -40, top: 32 });
    return emitter;
  }
}
